export const dnldCostBilling = (builder) => ({
    dnldCostBilling: builder.mutation({
        query: ({ loggedin_user_id, user_type_id, startDate, endDate }) => {
            return {
                url: '/downloadWhatsAppCostBilling',
                method: 'GET',
                params: { loggedin_user_id, user_type_id, startDate, endDate  },
                headers: {
                    'Content-Type':  'text/csv', 
                },
                responseHandler: (response) => response.blob(),
            };
        },
    }),
});